import React from "react";
import {
  Row,
  Col,
  Input,
  FormGroup,
  Card,
  CardBody,
  Label,
  Button,
} from "reactstrap";
import "./scheduler.css";
import Select  from "react-select";
import moment from 'moment-timezone'
import TextField from "@material-ui/core/TextField";
import SchedulerService from "../../services/api/Scheduler";
import {
  disablePastDate
} from "../../settings/shared/commonMethod";

class Scheduler extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      schedulerName: "",
      description: "",
      startDate: "",
      startTime: "",
      endDate: "",
      repeatType: "ONETIME",
      endsOn: "Never",
      offsetTmz:[],
      selectTimeZone:"",
      showtimeZone:false,
      errorSubmitted:false,
      errorMessage:"",
      repeatsOn:[],
      weekDaysList:[],
      monthdaysList:[],
      minutesList:[],
      monthList:[],
      rangeMinutes:0,
      rangeYear:2021,
      monthSelectList:[],
      daySelectList:[],
      monthSelect:"January",
      daySelect:1,
      startYearTime:"",
      dummyData:"",
      SchedulerId:"",
      schedulerPaticularData:{}
    };

  }


componentDidMount() {
  this.InitMethod();
  // Getting scheduler types
  this.getAllSchedulerTypes();
  if(this.props.SchedulerMode === "Update"){
     if(this.props.schedulerDataById !== undefined){
      this.setState({
        SchedulerId:this.props.schedulerDataById.id
       },()=>{
        this.ToBindSchedulerValues(this.props.schedulerDataById);
       })
     }
  }
}

componentWillReceiveProps(nextProps) {
  if(nextProps.schedulerDataById !== undefined){
    if (nextProps.schedulerDataById.id !== this.state.SchedulerId) {
      this.setState({
        SchedulerId:nextProps.schedulerDataById.id
       },()=>{
        this.ToBindSchedulerValues(nextProps.schedulerDataById);
       })
    }
  }
  
}



ToBindSchedulerValues = (response) =>{ 
  // console.log(response)
  let schedulerData = response;
  if(schedulerData.length !== 0 && schedulerData !== undefined){
    this.setState({
      schedulerName:schedulerData.name,
      description:schedulerData.description,
      repeatType:schedulerData.scheduleType,
      selectTimeZone:schedulerData.scheduleOn.timeZone,
      startDate:moment(new Date(schedulerData.scheduleOn.startDate)).format("YYYY-MM-DD"),
      startTime: moment(schedulerData.scheduleOn.startTime, "HH:mm:ss").format("HH:mm:ss"),
      loading: false,
      schedulerPaticularData:response
    },()=>{
      // console.log(this.state.schedulerPaticularData)
    });
    if(schedulerData.scheduleOn.endsOn){
      this.setState({
        endsOn: "On",
        endDate:moment(new Date(schedulerData.scheduleOn.endDate)).format("YYYY-MM-DD")
      });
    }
    if(schedulerData.scheduleType === "EVERYMONTH"){
       let dateArray = schedulerData.scheduleOn.dates; 
       if(dateArray.length !== 0){
        for(var a = 0 ; a < dateArray.length; a++){
          var index = this.state.monthdaysList.findIndex(item => item.name === dateArray[a])
          this.state.monthdaysList[index].checked = true;
        }
        this.setState({
          dummyData:""
        })
        
       }
    }
  }
  
}



InitMethod = () =>{
  
  var timeZones = moment.tz.names();
  var tzList=[];
  for (var i = 0 ; i < timeZones.length ; i++ ){
      tzList.push({
        label:" (GMT"+moment.tz(timeZones[i]).format('Z')+") " + timeZones[i],
        value: timeZones[i],
      }
      )
      this.setState({
        offsetTmz:tzList,
      })
  }

  this.state.selectTimeZone = moment.tz.guess();
    // getting mon,tue,wed.....
    var days  =  moment.weekdaysShort(true)
    days.push(days.shift()) // change monday to sunday order
    for(var j = 0; j < days.length; j++){
      this.state.weekDaysList.push({
        name:days[j],
        checked:false,
        dayOrder:j
      })
    }
    // getting value form 1 to 31 days.....
    for(var k = 1; k <= 31; k++){
      this.state.monthdaysList.push({
        name:k,
        checked:false,
        dayOrder:k
      })
    }

    // getting value form 1 to 60 minutes.....
    for(var l = 1; l <= 60; l++){
      this.state.minutesList.push({
        name:l,
        dayOrder:l
      })
    }

    // getting value form 1 to 12 months.....
    for(var m = 1; m <= 12; m++){
      this.state.monthList.push({
        name:m,
        dayOrder:m
      })
    }

    for(var index = 0; index < moment.months().length; index++){
      this.state.monthSelectList.push({
        label:moment.months()[index],
        value:moment.months()[index]
      })
    }

    for(var d = 1; d <= 31; d++){
      this.state.daySelectList.push({
        label:d,
        value:d
      })
    }

}

getAllSchedulerTypes = () =>{
  SchedulerService.getSchedulerTypes().then((response) => {
    // console.log(JSON.stringify(response))
    for(var i = 0; i < response.length; i++){
      this.state.repeatsOn.push({
        label:response[i].displayName,
        value:response[i].key
      })
    }
  });
}


handleChangeweeklyDates = (e,name) =>{
   var objIndex = this.state.weekDaysList.findIndex((obj => obj.name === name));
   this.state.weekDaysList[objIndex].checked = e.target.checked;
}

handleChangeEveryMonthDate = (e,name) =>{
  if(!this.props.EditFlag){
    var objIndex = this.state.monthdaysList.findIndex((obj => obj.name === name));
    this.state.monthdaysList[objIndex].checked = e.target.checked;
    this.setState({
      dummyData:""
    })
  }
}

handleChangeSliderMinutes = (e) =>{
   var input = document.getElementById("typeinp");
    var currentVal = input.value;
    this.setState({
      rangeMinutes: currentVal
    })
}

handleChangeSliderYear = (e) =>{
  var input = document.getElementById("typeyear");
   var currentVal = input.value;
   this.setState({
     rangeYear: currentVal
   })
}

toggleTimeZone = () => {
  if(!this.props.EditFlag){
    this.setState({
      showtimeZone: !this.state.showtimeZone,
    });
  }
};

handleChangeTimeZone = (event) => {
  this.setState({
    selectTimeZone: event.value,
    showtimeZone:false
  });
}

  clearFormDate = () =>{
    this.setState({
      schedulerName: "",
      description: "",
      startDate: "",
      startTime: "",
      endDate: "",
      repeatType: "ONETIME",
      endsOn: "Never",
    })
  }

  validateScheduler = () => {
    if (this.state.schedulerName === "" || this.state.schedulerName === undefined) {
      this.setErrorMessage("Please enter scheduler name");
    }else if (this.state.startDate === "" || this.state.startDate === undefined) {
      this.setErrorMessage("Please select start date");
    }else if (this.state.startTime === "" || this.state.startTime === undefined) {
      this.setErrorMessage("Please select start time");
    }else{
      if(this.state.repeatType === "ONETIME"){
          this.constructSchedulerDTO();
      }else if(this.state.repeatType === "DAILY"){
        if((this.state.endsOn !== "Never") && (this.state.endDate === "" || this.state.endDate === undefined)){
          this.setErrorMessage("Please select end date");
        }else{
          this.constructSchedulerDTO();
        }
      }else if(this.state.repeatType === "EVERYMONTH"){
        var dates = this.state.monthdaysList.filter(item=> item.checked === true);
        if((this.state.endsOn !== "Never") && (this.state.endDate === "" || this.state.endDate === undefined)){
          this.setErrorMessage("Please select end date");
        }else if(dates.length === 0 ){
          this.setErrorMessage("Please Select date range should be between 1 to 31");
        }else{
          this.constructSchedulerDTO();
        }
      }
      else if(this.state.repeatType === "WEEKLY"){
        var dates_week = this.state.weekDaysList.filter(item=> item.checked === true);
        if((this.state.endsOn !== "Never") && (this.state.endDate === "" || this.state.endDate === undefined)){
          this.setErrorMessage("Please select end date");
        }else if(dates_week.length === 0 ){
          this.setErrorMessage("Please Select Weeks range should be between Monday to Sunday");
        }else{
          this.constructSchedulerDTO();
        }
      }
    }
  }

  constructSchedulerDTO = () =>{
    this.setErrorMessage("");
    this.state.errorSubmitted = false;
    var scheduleDTO = {
      name: this.state.schedulerName,
      description: this.state.description,
      scheduleFor: this.props.ScheduleType,
      scheduleType: this.state.repeatType,
      scheduleOn: this.constructScheduleOnObject(),
    };
    // console.log(scheduleDTO)
    this.props.SchedulerUpdate(scheduleDTO,this.props.SchedulerMode);

  }


  constructScheduleOnObject = () =>{
      var scheduleObject = {}
      scheduleObject = {
          startDate:moment(this.state.startDate).format("MM/DD/YYYY"), 
          startTime: moment(this.state.startTime, ["h:mm A"]).format("HH:mm"),
          // timeZone:moment.tz(this.state.selectTimeZone).zoneAbbr(),
          timeZone:this.state.selectTimeZone,
          endsOn:this.state.endsOn === "Never" ? false : true,
          endDate:moment(this.state.endDate).isValid() ? moment(this.state.endDate).format("MM/DD/YYYY"):"", 
      }

      if(this.state.repeatType === "EVERYMONTH"){
         var datesSelcted = [];
         let dateArray = this.state.monthdaysList.filter(item=> item.checked === true);
         if(dateArray.length !== 0){
            for(var a = 0; a < dateArray.length ; a++){
                datesSelcted.push(dateArray[a].name)
            }  
            scheduleObject["dates"] = datesSelcted
         }       
      }
      
      if(this.state.repeatType === "WEEKLY"){
        var datesSelcted_Week = [];
        let dateArray = this.state.weekDaysList.filter(item=> item.checked === true);
        if(dateArray.length !== 0){
          for(var da = 0; da < dateArray.length ; da++){
            datesSelcted_Week.push(dateArray[da].dayOrder)
          }
          scheduleObject["weekDays"] = datesSelcted_Week
        }         
      }
      return scheduleObject;
  }

  setErrorMessage(message) {
    if (message === "") {
      this.setState({
        errorMessage: message,
        errorSubmitted: false,
      });
    } else {
      if(this.props.SchedulerMode === "Create"){
        document.getElementById("errorDiv").scrollIntoView()
      }
      this.setState({
        errorMessage: message,
        errorSubmitted: true,
      });
    }
  }

  render() {
    return (
        <div>
           {this.state.errorSubmitted && <Row id="errorDiv" className="errorBoxSchedule">
          <span style={{fontSize:14,color:"red"}}>
            {this.state.errorMessage}
          </span>
      </Row>}
          <Row>
          <Col xs="6">
          <TextField
            className={this.props.EditFlag ? "disableMode fullWidth" : "fullWidth"}
            id="outlined-required"
            label="Name *"
            value={this.state.schedulerName}
            onChange={(e) =>
              this.setState({ schedulerName: e.target.value })
            }
          />
         </Col>
         <Col xs="6">
          <TextField
            className={this.props.EditFlag ? "disableMode fullWidth" : "fullWidth"}
            id="outlined-required"
            label="Description"
            value={this.state.description}
            onChange={(e) =>
              this.setState({ description: e.target.value })
            }
          />
          </Col>
          </Row>
          <Row style={{marginTop:15}}>
          {!this.state.showtimeZone && <Col xs="12" style={{marginTop:8}}>
                <span className="" onClick={e=>this.toggleTimeZone()}>Time zone &nbsp; &nbsp; : &nbsp; &nbsp;<span className={this.props.EditFlag ? "disableMode":"showColor"}>{this.state.selectTimeZone !== "IST" ? (" (GMT"+moment.tz(this.state.selectTimeZone).format('Z')+") " + this.state.selectTimeZone) : "Invalid"} &nbsp; &nbsp;&nbsp;<i className="fas fa-pen"></i></span></span>
            </Col>}

            {/* <Col xs="6"style={{marginTop:8}}>
              <Select name="roleName"  options={this.state.offsetTmz} 
              value={this.state.offsetTmz.filter(item=>item.value === this.state.selectTimeZone)}
              onChange={this.handleChangeTimeZone} noValidate/>
            </Col> */}
          </Row>
          {this.state.showtimeZone && <Row style={{marginTop:8}}><Col xs="6"><Label><b>Choose Time zone</b></Label>
            <Select name="roleName"  options={this.state.offsetTmz} 
            value={this.state.offsetTmz.filter(item=>item.value === this.state.selectTimeZone)}
            onChange={this.handleChangeTimeZone} noValidate/></Col></Row>}

           <Row style={{marginTop:15}}>
            <Col xs="6">

                <FormGroup>
                  <Label><b>Repeats on  *</b></Label>

                  <Select name="repeatType" className={this.props.EditFlag?"disableMode":""} options={this.state.repeatsOn} 
                 value={this.state.repeatsOn.filter(item=>item.value === this.state.repeatType)}
              onChange={(e) =>
                this.setState({ repeatType: e.value,endsOn: "Never" })
              } noValidate/>
                </FormGroup>
            </Col>

            <Col xs="6">

            {this.state.repeatType === "WEEKDAYS" && <Row>

              
          <Col style={{marginTop:8, textAlign:"center",color:"#3f6bb8",fontWeight:600,paddingTop:15,paddingBottom:15}}>
          <Card>
          <CardBody>
          <div className="weekDays-selector">
           {this.state.weekDaysList.map((item, index) => (
             <>
             <input type="checkbox" desabled id={'weekday-'+ index} className="weekday" checked= {item.dayOrder < 5} />
            <label className={item.dayOrder < 5 ? "":"hideDay"} for={'weekday-'+ index}>{item.name}</label>
             </>
           ))}
            </div>
            </CardBody>
            </Card>
            </Col>
          </Row>}

          {this.state.repeatType === "WEEKEND" && <Row>
          <Col style={{marginTop:8, textAlign:"center",color:"#3f6bb8",fontWeight:600,paddingTop:15,paddingBottom:15}}>
          <Card>
          <CardBody>
          <div className="weekDays-selector" >
           {this.state.weekDaysList.map((item, index) => (
             <>
             <input type="checkbox" desabled id={'weekday-'+ index} className="weekday" checked= {item.dayOrder >= 5} />
             <label className={item.dayOrder >= 5 ? "":"hideDay"} for={'weekday-'+ index}>{item.name}</label>
             </>
           ))}
            </div>
            </CardBody>
            </Card>
            </Col>
          </Row>}

          {this.state.repeatType === "WEEKLY" && <Row >
           <Col style={{marginTop:8, textAlign:"center",color:"#3f6bb8",fontWeight:600,paddingTop:15,paddingBottom:15}}>
           <Card>
          <CardBody>
           <div class="weekDays-selector">
           {this.state.weekDaysList.map((item, index) => (
             <>
             <input type="checkbox" id={'weekday-'+ index} class="weekday" onChange={e=>this.handleChangeweeklyDates(e,item.name)} />
             <label htmlFor={'weekday-'+ index}>{item.name}</label>
             </>
           ))}
            </div>
            </CardBody>
            </Card>
            </Col>
          </Row>}

          {this.state.repeatType === "EVERYMONTH" && <Row>
          <Col style={{color:"#3f6bb8",fontWeight:600}}>
          <Card>
          <CardBody>
          <div className="weekDays-selector">
           {this.state.monthdaysList.map((item, index) => (
             <>
             <input type="checkbox" id={'weekday-'+ index}   checked={item.checked} className="weekday" onChange={e=>this.handleChangeEveryMonthDate(e,item.name)} />
             <label className="roundsmallCheckbox" for={'weekday-'+ index}>{item.name}</label>
             </>
           ))}
            </div>
            </CardBody>
            </Card>
            </Col>
          </Row>}
           
            </Col>
          </Row>

        <Card style={{marginTop:20}}>
        <CardBody>

          {this.state.repeatType === "EVERYHOUR" && <Row>
          <Col style={{marginTop:8, textAlign:"center",color:"#3f6bb8",fontWeight:600}}>
            <Card>
            <CardBody>
            <span>0&nbsp;&nbsp;</span>
            <input 
            id="typeinp" 
            type="range" 
            min="0" max="23" 
            value={this.state.rangeMinutes} 
            onChange={this.handleChangeSliderMinutes}
            step="1"/>
            <span>&nbsp;&nbsp;23</span>
            <Row>
              <Col>
            <span>Every Hour &nbsp;&nbsp;:&nbsp;&nbsp;{this.state.rangeMinutes}</span>
            </Col>
            </Row>
            </CardBody>
            </Card>
            </Col>
          </Row>}

          {this.state.repeatType === "EVERYYEAR" && <Row>
          <Col style={{marginTop:8, textAlign:"center",color:"#3f6bb8",fontWeight:600}}>
            <Card>
            <CardBody>
            <Row>
              <Col xs="2">
                  <Select name="daySelect"  options={this.state.daySelectList} 
                 value={this.state.daySelectList.filter(item=>item.value === this.state.daySelect)}
              onChange={(e) =>
                this.setState({ daySelect: e.value })
              } noValidate/>
                 
              </Col>

              <Col xs="4">
                  <Select name="monthSelect"  options={this.state.monthSelectList} 
                 value={this.state.monthSelectList.filter(item=>item.value === this.state.monthSelect)}
              onChange={(e) =>
                this.setState({ monthSelect: e.value })
              } noValidate/>
              </Col>

              <Col xs="4" style={{border:"1px solid #d3d3d3",borderRadius:5}}>
              <Input
                type="time"
                style={{border:"none"}}
                value={this.state.startYearTime}
                onChange={(e) =>
                  this.setState({ startYearTime: e.target.value })
                }
              />
              </Col>
            </Row>
            </CardBody>
            </Card>
            </Col>
          </Row>}

          {((this.state.repeatType === "DAILY") ||  (this.state.repeatType === "ONETIME") 
          || (this.state.repeatType === "WEEKDAYS") || (this.state.repeatType === "WEEKEND")
          || (this.state.repeatType === "WEEKLY") || (this.state.repeatType === "EVERYMONTH")
          || (this.state.repeatType === "EVERYHOUR"))&& <Row>
          <Col xs="6">
          <FormGroup>
          <Label><b>Start Date  *</b></Label>
              <Input
                type="date"
                className={this.props.EditFlag ? "disableMode dateStyle" : "dateStyle"}
                min={disablePastDate()}
                value={this.state.startDate}
                onChange={(e) => this.setState({ startDate: e.target.value })}
              />
              </FormGroup>
              </Col>
              <Col xs="6">
              <FormGroup>
          <Label><b>Time *</b></Label>
              <Input
                type="time"
                className={this.props.EditFlag ? "disableMode dateStyle" : "dateStyle"}
                value={this.state.startTime}
                onChange={(e) =>
                  this.setState({ startTime: e.target.value })
                }
              />
              </FormGroup>
          </Col>
          </Row>}

          {((this.state.repeatType === "DAILY") || (this.state.repeatType === "WEEKDAYS") ||
          (this.state.repeatType === "WEEKEND") || (this.state.repeatType === "WEEKLY")
          || (this.state.repeatType === "EVERYMONTH") || (this.state.repeatType === "EVERYHOUR")
          || (this.state.repeatType === "EVERYYEAR")) && <Row>
          <Col>
          <FormGroup>
                  <Label><b>Ends</b></Label>
                  <FormGroup check inline>
                    <Label check>
                      <Input
                        type="radio"
                        disabled={this.props.EditFlag}
                        name="rbtnEndsOn"
                        checked={this.state.endsOn === "Never" ? true : false}
                        onChange={(e) => {
                          this.setState({ endsOn: "Never" });
                        }}
                      />
                      Never
                    </Label>
                  </FormGroup>
                  <FormGroup check inline>
                    <Label check>
                      <Input
                        type="radio"
                        name="rbtnEndsOn"
                        disabled={this.props.EditFlag}
                        checked={this.state.endsOn === "On" ? true : false}
                        onChange={(e) => {
                          this.setState({ endsOn: "On" });
                        }}
                      />
                      On
                    </Label>
                  </FormGroup>
                  {this.state.endsOn === "On" ? (
                    <FormGroup>
                      <Row>
                        {this.state.repeatType !== "EVERYYEAR" && <Col xs="6">
                        <Label><b>End Date  *</b></Label>

                          <Input
                            type="date"
                            className={this.props.EditFlag ? "disableMode dateStyle":"dateStyle"}
                            min={disablePastDate()}
                            value={this.state.endDate}
                            onChange={(e) =>
                              this.setState({ endDate: e.target.value })
                            }
                          />
                        </Col>}
                        {this.state.repeatType === "EVERYYEAR" && <Col style={{color:"#3f6bb8",fontWeight:600}}>
                        <Label><b>End Year</b></Label><br/>

                        <span>2021&nbsp;&nbsp;</span>
                        <input 
                        id="typeyear" 
                        type="range" 
                        min="2021" max="2121" 
                        value={this.state.rangeYear} 
                        onChange={this.handleChangeSliderYear}
                        step="1"/>
                        <span>&nbsp;&nbsp;2121</span>
                        <Row>
                          <Col>
                        <span>Year &nbsp;&nbsp;:&nbsp;&nbsp;{this.state.rangeYear}</span>
                        </Col>
                        </Row>
                        </Col>}
                      </Row>
                    </FormGroup>
                  ) : (
                    <div />
                  )}
                </FormGroup>
                </Col>
          </Row>}

          </CardBody>
          </Card>

          <Card>
          <CardBody style={{fontSize:13}}>
          <Row style={{marginBottom:20}}>
            <Col xs="6">
              <span> <b>Created By &nbsp;&nbsp;: </b>{this.state.schedulerPaticularData.createdBy}</span>

            </Col>
            <Col xs="6">
            <span><b>Created Date&nbsp;&nbsp;:</b>{this.state.schedulerPaticularData.createdDate !== null ? <span>&nbsp;{moment(this.state.schedulerPaticularData.createdDate).format("MMM DD, YYYY HH:mm")}</span> : "    ---"}</span>

            </Col>
          </Row>

          <Row>
            <Col xs="6">
            <span><b>Last Event&nbsp;&nbsp;&nbsp;&nbsp;:</b> {this.state.schedulerPaticularData.lastTriggeredAt !== null ? moment(this.state.schedulerPaticularData.lastTriggeredAt).format("MMM DD, YYYY HH:mm") : "---"}</span><br/>
            </Col>
            <Col xs="6">
            <span><b>Next Event&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:</b>{this.state.schedulerPaticularData.nextTriggerAt !== null ? <span style={{color:"#4285f4",fontWeight:600}}>&nbsp;{moment(this.state.schedulerPaticularData.nextTriggerAt).format("MMM DD, YYYY HH:mm")}</span> : "    ---"}</span>
            </Col>
          </Row>
          </CardBody>
          </Card>
          
        {/* <hr/> */}
        {!this.props.EditFlag && <Row style={{float:"right"}}>
        {/* <Col>
          <FormGroup>
            <Button
              color="secondary"
              size="sm"
              type="submit"
              onClick={this.props.ToggleScheduler}
            >
              Cancel
        </Button>
          </FormGroup>
              </Col> */}
            <Col>
              <FormGroup>
                <Button
                  color="primary"
                  size="sm"
                  type="submit"
                  onClick={this.validateScheduler}
                >
                  {this.props.SchedulerMode === "Update" ? "Update" : "Schedule"}
                </Button>
              </FormGroup>
            </Col>
        </Row> }
      </div>
    );
  }
}

export default Scheduler;
